export function ignoreStaleResponse(activeId:string, requestId:string, actionName): boolean {

  if (activeId && activeId !== requestId) {
    if (actionName) {
      console.warn(
        `Ignoring stale response for ${actionName}: ${requestId}, active is: ${activeId}`
      );
    }
    return true;
  }
  return false;
}